import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { onlineOfflineDevice } from "../../redux/actions/controlPanel/onlineOfflineDevice";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode } from "primereact/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-regular-svg-icons";

const DeviceTabs = () => {
  const dispatch = useDispatch();
  const deviceData = useSelector((state) => state.onlineOfflineDeviceReducer);
  const [deviceList, setDeviceList] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
  const navigate = useNavigate();

  const { role, id } = JSON.parse(localStorage.getItem("userData")) || {};

  useEffect(() => {
    dispatch(onlineOfflineDevice());
  }, [dispatch]);

  useEffect(() => {
    if (deviceData?.data?.length) {
      setDeviceList(deviceData?.data);
      setIsLoading(false);
    }
  }, [deviceData]);

  useEffect(() => {
    if (deviceData?.loading) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [deviceData]);

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;
    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const renderHeader = () => {
    return (
      <div className="flex justify-end">
        <span className="flex items-center">
          <span className="font-normal">Search:</span>
          <InputText
            className="ml-1 p-1 text-sm font-normal border-1 border-gray-400"
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            placeholder="Keyword Search"
          />
        </span>
      </div>
    );
  };

  const header = renderHeader();

  const actionBodyTemplate = (rowData) => {
    return (
      <button onClick={() => navigate(`/details/${rowData.id}/${id}/1`)}>
        View <FontAwesomeIcon icon={faEye} />
      </button>
    );
  };

  return (
    <>
      <DataTable
        value={isLoading ? [] : deviceList}
        filters={filters}
        removableSort
        tableStyle={{ minWidth: "50rem" }}
        header={header}
        paginator
        rows={10}
        rowsPerPageOptions={[10, 20, 30]}
        totalRecords={deviceList?.length}
        emptyMessage={
          isLoading ? (
            <p className="text-center ">Loading...</p>
          ) : (
            "No Modules Found."
          )
        }
        className="bg-none"
        showGridlines
      >
        <Column
          className="border-1 text-[14px] p-1 text-center"
          body={(_, { rowIndex }) => rowIndex + 1}
          header="Sr. No"
        ></Column>
        <Column
          className="border-1 text-[14px] p-1 text-center"
          field="node"
          header="Node"
          sortable
        ></Column>
        <Column
          className="border-1 text-[14px] p-1 text-center"
          field="moduleName"
          header="Module"
          sortable
        ></Column>
        <Column
          className="border-1 text-[14px] p-1 text-center"
          field="description"
          header="Description"
          sortable
        ></Column>
        {role === 0 && (
          <Column
            className="border-1 text-[14px] p-1 text-center"
            field="tableName"
            header="Table"
            sortable
          ></Column>
        )}
        <Column
          className="border-1 text-[14px] p-1 text-center"
          field="site_name"
          header="Site Name"
          sortable
        ></Column>
        <Column
          className="border-1 text-[14px] p-1 text-center"
          field="location"
          header="Location"
          sortable
        ></Column>
        <Column
          className="border-1 text-[14px] p-1 text-center"
          field="EventStartedOn"
          header="Event Started On"
          sortable
        ></Column>
        <Column
          className="border-1 text-[14px] p-1 text-center"
          field="EventEndedOn"
          header="Event Ended On"
          sortable
        ></Column>
        <Column
          className="border-1 py-2 pl-[2rem] text-center"
          // body={switchBodyTemplate}
          field="status"
          header="Status"
        ></Column>
        <Column
          className="border-1 py-2 pl-[2.5rem] text-[#FE4C4C] text-center"
          body={actionBodyTemplate}
          header="Action"
        ></Column>
      </DataTable>
    </>
  );
};

export default DeviceTabs;
